/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Booking/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFormat from 'Data/format.js'
import AppointmentBookingStateTextWithIcon from 'DesignSystem/AppointmentBookingStateTextWithIcon/index'
import AppointmentCard from 'DesignSystem/AppointmentCard/index'
import React from 'react'
import Resources from './Resources/index'
import Time from './Time/index'
import Type from './Type/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Booking({
  children,
  viewPath = "/DesignSystem/PatientInformation/Content/AppointmentBooking/Content/Booking"
  
}) {
let patientBookingAppointmentTypeDisplayColorIdValueData = fromData.useDataFormat({ viewPath,
context: 'patient',
path: 'booking.appointment.type.display_color_id',
format: fromFormat.appointmentTypeColor,
})
let dtSpaceXxxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxxs'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let patientBookingStateValueData = fromData.useDataValue({ viewPath,
context: 'patient',
path: 'booking.state',
})
let patientBookingConfirmationStatusValueData = fromData.useDataValue({ viewPath,
context: 'patient',
path: 'booking.confirmation_status',
})
  return (<React.Fragment
>
<div
  data-testid="Booking.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<AppointmentCard
  viewPath={`${viewPath}/AppointmentCard`}
 data="patient.booking.appointment.type.display_color_id"
 format="/Data/format.js appointmentTypeColor"
 appointmentColor={patientBookingAppointmentTypeDisplayColorIdValueData}
 marginBottom={0}
>
{childProps => (
<div
  data-testid="Booking.Vertical"
  data-view-path={viewPath}
 style={{'--g-1-22SRg2': typeof dtSpaceXxxs === 'number' ? `${dtSpaceXxxs}px` : dtSpaceXxxs}}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="Booking.Horizontal:1"
  data-view-path={viewPath}
 style={{'--g-1-22SRg2': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Horizontal1}`}
>
<Type
  viewPath={`${viewPath}/Type`}
/>
<AppointmentBookingStateTextWithIcon
  viewPath={`${viewPath}/AppointmentBookingStateTextWithIcon`}
 data="patient.booking.state"
 state={patientBookingStateValueData}
 data="patient.booking.confirmation_status"
 confirmation_status={patientBookingConfirmationStatusValueData}
 show_icon={true}
 size="tiny"
/>
</div>
<Time
  viewPath={`${viewPath}/Time`}
/>
<Resources
  viewPath={`${viewPath}/Resources`}
/>
</div>
)}
</AppointmentCard>
</div>
{children}
</React.Fragment>)
}